import { Injectable } from '@angular/core';
import { Cart, Product } from '../../types/products';
import { Subject } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { AddToCartInput } from 'src/app/@resources/graphql/types/types';
import {
  ADDTOCARTORINCREASE,
  CLEARCART,
  CREATECART,
  DECREASECARTITEM,
  DELETECARTITEM,
  MIGRATECLIENTCARTWITHCUSTOMERCART,
} from 'src/app/@resources/graphql/mutations/mutations';
import { CART } from 'src/app/@resources/graphql/queries/queries';

@Injectable({ providedIn: 'root' })
export class CartService {
  public cartUpdates = new Subject<string>();
  public cartUpdates$ = this.cartUpdates.asObservable();
  public cartItmes: Product[] = [];
  public cartInfo: Cart;
  public get count(): number {
    return this.cartItmes.reduce((c, t1) => t1.qty + c, 0);
  }
  constructor(private apollo: Apollo) {}
  addToCart(Obj: AddToCartInput) {
    console.log(Obj);
    const res = this.apollo.mutate<any>({
      mutation: ADDTOCARTORINCREASE,
      variables: { input: Obj },
    });
    res.subscribe(({ data }) => {
      console.log(data);
      this.cartInfo = data.addItemToCartOrIncrement;
      this.cartItmes = data.addItemToCartOrIncrement.items;
      this.cartItmes.forEach(
        (item :any) =>
          (item.name =
            localStorage.getItem('lang')?.indexOf('ar') !== -1
              ? item.arabic_name
              : item.english_name)
      );
      this.cartItmes = data.addItemToCartOrIncrement.items;
      this.cartUpdates.next();
    });
    return this.cartInfo;
  }
  deleteCartItem(cartItemId: string, cartId: string) {
    const res = this.apollo.mutate<any>({
      mutation: DELETECARTITEM,
      variables: { cartItemId: cartItemId, cartId: cartId },
    });
    res.subscribe(({ data }) => {
      console.log(data);
      this.cartInfo = data.deleteCartItem;
      this.cartItmes = data.deleteCartItem.items;
      this.cartUpdates.next();
    });
    return this.cartItmes;
  }
  decreamentCartItem(cartItemId: string, cartId: string) {
    const res = this.apollo.mutate<any>({
      mutation: DECREASECARTITEM,
      variables: { cartItemId: cartItemId, cartId: cartId },
    });
    res.subscribe(({ data }) => {
      this.cartInfo = data.decrementCartItem;
      this.cartItmes = data.decrementCartItem.items;
      this.cartItmes.forEach(
        (item :any) =>
          (item.name =
            localStorage.getItem('lang')?.indexOf('ar') !== -1
              ? item.arabic_name
              : item.english_name)
      );
      this.cartUpdates.next();
    });
    return this.cartItmes;
  }
  clearCart(cartId: string) {
    const res = this.apollo.mutate<any>({
      mutation: CLEARCART,
      variables: { cartId: cartId },
    });
    res.subscribe(({ data }) => {
      this.cartInfo = data.clearCart;
      this.cartItmes = data.clearCart.items;
      this.cartUpdates.next();
    });
    return this.cartInfo;
  }
  getCartItems() {
    const cartId: string =
      localStorage.getItem('amandaCartId') ||
      localStorage.getItem('amandaClientCartId') ||
      '';
    const res = this.apollo.query<any>({
      query: CART,
      variables: { cartId },
    });
    res.subscribe(({ data }) => {
      console.log(data);
      this.cartInfo = data.cart;
      this.cartItmes = data.cart.items;
      this.cartItmes = data.cart.items
      this.cartItmes.forEach(
        (item :any) =>
          (item.name =
            localStorage.getItem('lang')?.indexOf('ar') !== -1
              ? item.arabic_name
              : item.english_name)
      );
      this.cartUpdates.next();
    });
    return res;
  }

  createCart(customerId?: string) {
    const res = this.apollo.mutate<any>({
      mutation: CREATECART,
      variables: { customerId },
    });
    res.subscribe(({ data }) => {
      this.cartInfo = data.createCart;
      this.cartItmes = data.createCart.items;
      !customerId
        ? localStorage.setItem('amandaClientCartId', data.createCart.cartId)
        : localStorage.setItem('amandaCartId', data.createCart.cartId);
      this.cartUpdates.next();
    });
    return this.cartInfo;
  }

  migrateClientCartWithLoginCart() {
    const clientCartId = localStorage.getItem('amandaClientCartId');
    const customerCartId = localStorage.getItem('amandaCartId');
    const res = this.apollo.mutate<any>({
      mutation: MIGRATECLIENTCARTWITHCUSTOMERCART,
      variables: { clientCartId, customerCartId },
    });
    res.subscribe(({ data }) => {
      console.log(data);
      this.cartInfo = data.migrateClientWithCustomer;
      this.cartItmes = data.migrateClientWithCustomer.items;
      this.cartUpdates.next();
    });
    return this.cartInfo;
  }
}
